import getPropFromModule from './getPropFromModule';

import { HAS_FETCHED } from '../model';

const getIsMenuFetched = state => getPropFromModule(state, HAS_FETCHED);

export default getIsMenuFetched;
